import { jsxs as d, jsx as o } from "react/jsx-runtime";
import { memo as C, useState as p, Children as L, cloneElement as A } from "react";
import { Typography as E } from "./index59.mjs";
import { isDefined as c } from "./types3.mjs";
import { IconButton as b, Popper as v, Paper as y, ClickAwayListener as S, MenuList as B, menuItemClasses as I } from "@mui/material";
import w from "./PersonRounded.mjs";
import { StyledEmailWrapper as D, Divider as M, StyledLanguageSelectorWrapper as O } from "./styles67.mjs";
import { LanguageSelect as R } from "./index35.mjs";
const _ = "user-menu-button", $ = `${_}-menu`, N = C(
  ({
    email: u,
    children: n,
    autoCloseOnClick: m = !0,
    languageSelectProps: t,
    popperProps: g = {}
  }) => {
    const [i, a] = p(null), r = !!i, [h, l] = p(!1), f = (e) => {
      a(e.currentTarget);
    }, s = () => {
      h || a(null);
    }, k = (e) => (x) => {
      m && s(), c(e) && e(x);
    };
    return /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ o(
        b,
        {
          size: "small",
          "aria-controls": r ? $ : void 0,
          "aria-haspopup": "true",
          "aria-expanded": r ? "true" : void 0,
          onClick: f,
          children: /* @__PURE__ */ o(w, {})
        }
      ),
      /* @__PURE__ */ o(
        v,
        {
          anchorEl: i,
          open: r,
          placement: "bottom-start",
          ...g,
          children: /* @__PURE__ */ o(
            y,
            {
              sx: (e) => ({
                width: "210px",
                backgroundColor: e.palette.background.level3,
                boxShadow: e.tokens.shadow.small,
                border: `1px solid ${e.palette.other.divider}`,
                borderRadius: e.tokens.radius[8]
              }),
              children: /* @__PURE__ */ o(S, { onClickAway: s, children: /* @__PURE__ */ d("div", { children: [
                /* @__PURE__ */ o(D, { children: /* @__PURE__ */ o(E.Caption, { children: u }) }),
                /* @__PURE__ */ o(M, {}),
                t && /* @__PURE__ */ o(O, { children: /* @__PURE__ */ o(
                  R,
                  {
                    ...t,
                    onOpen: () => l(!0),
                    onClose: () => l(!1)
                  }
                ) }),
                /* @__PURE__ */ o(
                  B,
                  {
                    autoFocusItem: r,
                    sx: (e) => ({
                      padding: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: e.tokens.spacing[8],
                      [`.${I.root}`]: {
                        margin: 0,
                        height: e.spacing(5),
                        borderRadius: `${e.tokens.radius[8]} !important`
                      }
                    }),
                    children: c(n) && L.map(
                      n,
                      (e) => A(e, {
                        onClick: k(e?.props.onClick)
                      })
                    )
                  }
                )
              ] }) })
            }
          )
        }
      )
    ] });
  }
);
export {
  N as UserMenu
};
//# sourceMappingURL=index102.mjs.map
